import Vue from 'vue';
import Vuex from 'vuex';
import * as auth from '@/store/modules/auth.js';
import * as corporation from '@/store/modules/corporation.js';
import * as brand from '@/store/modules/brand.js';
import * as school from '@/store/modules/school.js';
import * as video_viewing from '@/store/modules/video_viewing.js';
import * as video_viewing_pole from '@/store/modules/video_viewing_pole.js';
import * as teacher from '@/store/modules/teacher.js';
import * as tamai_class from '@/store/modules/tamai_class.js';
import * as student from '@/store/modules/student.js';
import * as student_history from '@/store/modules/student_history.js';
import * as student_importer from '@/store/modules/student_importer.js';
import * as student_trial_registration from '@/store/modules/student_trial_registration.js';
import * as course from '@/store/modules/course.js';
import * as frozen from '@/store/modules/frozen.js';
import * as ask_teacher from '@/store/modules/ask_teacher.js';
import * as advance_student from '@/store/modules/advance_student.js';
import * as role from '@/store/modules/role.js';
import * as home_item from '@/store/modules/home_item.js';
import * as sidebar_item from '@/store/modules/sidebar_item.js';
import * as sidebar_progress from '@/store/modules/sidebar_progress.js';
import * as setting from '@/store/modules/setting.js';
import * as test_preparation_print from '@/store/modules/test_preparation_print.js';
import * as notification from '@/store/modules/notification.js';
import * as form from '@/store/modules/form.js';
import * as gender from '@/store/modules/gender.js';
import * as employment_status from '@/store/modules/employment_status.js';
import * as country from '@/store/modules/country.js';
import * as school_year from '@/store/modules/school_year.js';
import * as product from '@/store/modules/product.js';
import * as teaching_material from '@/store/modules/teaching_material.js';
import * as activation from '@/store/modules/activation.js';
import * as billing from '@/store/modules/billing.js';
import * as trial_teaching_material from '@/store/modules/trial_teaching_material.js';
import * as book from '@/store/modules/book.js';
import * as loading from '@/store/modules/loading.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    corporation,
    brand,
    school,
    video_viewing,
    video_viewing_pole,
    teacher,
    tamai_class,
    student,
    student_history,
    student_importer,
    student_trial_registration,
    course,
    frozen,
    ask_teacher,
    advance_student,
    role,
    home_item,
    sidebar_item,
    sidebar_progress,
    setting,
    test_preparation_print,
    notification,
    form,
    gender,
    country,
    employment_status,
    school_year,
    product,
    teaching_material,
    activation,
    billing,
    trial_teaching_material,
    book,
    loading,
  },
});
